import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import ButtonNode from './button-node';
import TextAreaNode from './textarea-node';
import {filterNodeProperties} from '../../../../utilities/filter-node-properties';
import FeedbackItem from './feedback-item-node';
import {handleEvent} from '../../../../events/event-handler';
import RangeFieldNode from './range-field-node';
import TextFieldNode from './text-field-node';
import MatchFieldNode from './match-field-node';
import {isEmpty} from '../../../../utilities/validation';
import {saveAnswer} from '../../../../actions/jre';
import * as api from '../../../../utilities/api';
import {formatErrors} from '../../../../actions/errors';
import ActionButtonNode from './action-button-node';

const getDataFromNode = function (node) {
    const keys = ['enabled', 'required', 'attempts', 'fontsize', 'fontcolor'];
    return filterNodeProperties(node, keys, {val: node.val});
};

const getDataFromFeedbackNode = function (node) {
    const keys = ['id', 'title', 'audio', 'feedback_type'];
    return filterNodeProperties(node, keys, {val: node.val});
};

const getChildNodeTypes = function (node) {
    const rangeNodes = node.childrenNamed('range_field_node') || null;
    const matchNodes = node.childrenNamed('match_field_node') || null;
    const textAreaNodes = node.childrenNamed('text_area_node') || null;
    const textFieldNodes = node.childrenNamed('text_field_node') || null;

    let typesList = [];
    if (rangeNodes && rangeNodes.length > 0) {
        typesList.push('range_field');
    }
    if (matchNodes && matchNodes.length > 0) {
        typesList.push('match_field');
    }
    if (textAreaNodes && textAreaNodes.length > 0) {
        typesList.push('text_area');
    }
    if (textFieldNodes && textFieldNodes.length > 0) {
        typesList.push('text_field');
    }

    return typesList;

};

const getStateFromProps = function(props = {}) {
    const rangeNodes = props.node.childrenNamed('range_field_node') || null;
    const matchNodes = props.node.childrenNamed('match_field_node') || null;
    const textAreaNodes = props.node.childrenNamed('text_area_node') || null;
    const textFieldNodes = props.node.childrenNamed('text_field_node') || null;

    return {
        ...getDataFromNode(props.node),
        textAreaNodes,
        rangeNodes,
        matchNodes,
        textFieldNodes,
    };
};

class TeNode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...getStateFromProps(props),
            currentFeedbackItem: null,
            teCompleted: false,
            typesList: getChildNodeTypes(props.node),
            rangeFieldAnswers: {},
            matchFieldAnswers: {},
            textFieldAnswers: {},
            textAreaAnswers: {},
            numOfAttempts: 0,
            rangeFieldAnswerStatusOb: null,
            textFieldAnswerStatusOb: null,
            matchFieldAnswerStatusOb: null,
            textAreaAnswerStatusOb: null,
            savedAnswers: {},
            updateCount: 0,
            completeSaving: false,
            answers: {}
        };

        // The following are used for (textFieldNodes - MO.ALTE.3.4.2: 105)

        this.state.overlayMask = this.state.enabled === '0';
        // this.state.overlayMask =  isEmpty(this.state.textFieldNodes); //when text_field_nodes exist, we dont want an overlay as there may be a te_node child button that enables the text nodes
        this.state.disableTeNodes = this.state.textFieldNodes; //when text_field_nodes exist, we use disableTeNodes to disable textboxes/buttons because there is no overlay

        this.enableTe = this.enableTe.bind(this);
        this.updateAnswerProgress = this.updateAnswerProgress.bind(this);
        this.disableTe = this.disableTe.bind(this);
        this.saveStudentAnswer = this.saveStudentAnswer.bind(this);
        this.evaluateAllChildrenNodes = this.evaluateAllChildrenNodes.bind(this);
    }

    componentDidMount() {
        const {node : {attr : {required}}, disableJREAppPlayerContainerButtons } = this.props;
        if(required){
            disableJREAppPlayerContainerButtons('requiredNodeNotCompleted', 'TeNode componentDidMount');
        }

        document.addEventListener('jre-te-enabled', this.enableTe);
        document.addEventListener('jre-te-disabled', this.disableTe);
    }

    componentWillUnmount() {
        const {node : {attr : {required}}, enableJREAppPlayerContainerButtons } = this.props;
        if(required){
            enableJREAppPlayerContainerButtons('requiredNodeNotCompleted', 'TeNode componentWillUnmount');
        }
        document.removeEventListener('jre-te-enabled', this.enableTe);
        document.removeEventListener('jre-te-disabled', this.disableTe);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.node !== nextProps.node) {
            this.setState({
                ...getStateFromProps(nextProps)
            });
        }
    }

    enableTe(e) {
        if ((typeof this.props.node.attr.id !== undefined) && (typeof e.detail.target !== undefined)
            && this.props.node.attr.id.toLowerCase() === e.detail.target.toLowerCase()) {
            this.setState({overlayMask: false, disableTeNodes: false});
        }
    }

    disableTe(e) {
        if ((typeof this.props.node.attr.id !== undefined) && (typeof e.detail.target !== undefined)
            && this.props.node.attr.id.toLowerCase() === e.detail.target.toLowerCase()) {
            this.setState({overlayMask: true});
        }
    }

    onChangeRangeField(e) {
        const { rangeFieldAnswers = {}} = this.state;
        rangeFieldAnswers[e.target.name] = e.target.value;

        this.setState({ rangeFieldAnswers });
    }

    onChangeTextField(e) {
        const { textFieldAnswers = {}} = this.state;
        textFieldAnswers[e.target.name] = e.target.value;

        this.setState({ textFieldAnswers });
    }

    onChangeTextAreaField(e) {
        let { textAreaAnswers = {}} = this.state;
        textAreaAnswers[e.target.name] = e.target.value;

        this.setState({ textAreaAnswers: textAreaAnswers });
    }

    onChangeMatchField(e) {
        const {matchFieldAnswers = {}, matchNodes = []} = this.state;
        const matchingNode = matchNodes.find(node => node.attr.id === e.target.name);
        if (matchingNode) {
            // patterns are in the format `pattern="CIci"` (MO.ELEC.3.0.0a - 722)
            // Only characters in the pattern are allowed characters, and there can only be one character in total selected by the user
            const pattern = (matchingNode.attr.pattern ? matchingNode.attr.pattern.split('') : null);

            // if pattern exists, and the user input is not a backspace
            if (pattern && !(e.target.value === '')) {
                // if pattern isn't matched, or if input length is greater than 1 (patterns can only be single input (MO.ELEC.3.0.0a - 722))
                if(!pattern.includes(e.target.value) || (e.target.value.length > 1) ){
                    return;
                }
            }

            matchFieldAnswers[e.target.name] = e.target.value;
            this.setState({ matchFieldAnswers });
        }
    }

    saveStudentAnswer(key, val = '') {
        const {saveAnswer,users} = this.props;
        let {answers = {}} = this.state;

        if (typeof key !== 'undefined' && !isEmpty(key) && !isEmpty(val)) {
            answers[key] = val;
            this.setState({ answers: answers });
            saveAnswer({[key]: val},users);
        }

    }

    updateAnswerProgress() {
        return new Promise(resolve => {
            const {moduleID, sessionNum, pageNum, formatErrors} = this.props;
            let {answers = {}} = this.state;

            let sessionNumber = 1;
            if (parseInt(sessionNum) > 0) {
                sessionNumber = sessionNum;
                if (sessionNumber > 7) sessionNumber = 7;
            }

            let formattedAnswers = [];
            Object.entries(answers).map(studentAnswer => {
                if (!isEmpty(studentAnswer[0]) && !isEmpty(studentAnswer[1])) {
                    let tempObject = {};
                    tempObject[studentAnswer[0]] = studentAnswer[1];
                    formattedAnswers.push(tempObject);
                }
            });

            let payload = {
                moduleId: moduleID,
                sessionNum: sessionNumber,
                pageNum: pageNum,
                completed: false,
                answers: JSON.stringify(formattedAnswers)
            };
            window.contentparams = JSON.parse(localStorage.getItem('contentparams'));
            api.setModuleProgress(payload,window.contentparams)
                .then(()=> resolve()) // Resolve Promise after variables are saved
                .catch(err => formatErrors(err));
        });
    }

    getCorrectRangeFieldAnswers() {
        const {rangeNodes = [], rangeFieldAnswers = {}} = this.state;
        const correctAnswers = rangeNodes.reduce(
            (answer, n) => {
                let userAnswer = rangeFieldAnswers[n.attr.id];
                let correctAnswer = Number(n.attr.answer);
                if (userAnswer !== undefined) {
                    // Accept answer only if it's within range.
                    if (parseFloat(userAnswer) >= parseFloat(n.attr.min) && parseFloat(userAnswer) <= parseFloat(n.attr.max)) {
                        correctAnswer = rangeFieldAnswers[n.attr.id];
                    }
                }
                return {...answer, [n.attr.id]: correctAnswer};
            }, {}
        );
        return correctAnswers;
    }

    getCorrectMatchFieldAnswers() {
        const {matchNodes = []} = this.state;
        const correctAnswers = matchNodes.reduce(
            (answer, n) => {
                const firstCorrectAnswer = n.attr.answer.split('|')[0];
                return {...answer, [n.attr.id]: firstCorrectAnswer};
            }, {}
        );
        return correctAnswers;
    }

    checkMatchFieldAnswer() {
        let {numOfAttempts = 0, teCompleted = false, matchNodes = [], matchFieldAnswers = {}} = this.state;
        const hasMoreAttempts = this.hasMoreAttempts();
        let feedbackNode = null;
        let isAnswerCorrect = false;
        let allAnswersCorrect;
        let allAnswers = [];

        const answerStatusOb = matchNodes.reduce(
            (answerStatus, n) => {
                const xmlVariable = n.attr.variable;
                const userAnswer = (matchFieldAnswers[n.attr.id] ? matchFieldAnswers[n.attr.id].trim() : undefined);

                // collect correct answers, and remove surrounding whitespace (MO.WTRQ.3.2.0: 112)
                const correctAnswersList = n.attr.answer.split('|').map(answer => answer.trim());
                isAnswerCorrect = correctAnswersList.includes(userAnswer); // Accept any answer that's contained in the list of acceptable answers.
                const firstCorrectAnswer = n.attr.answer.split('|')[0];

                let status = null;
                if (isAnswerCorrect) {
                    status = 'correct';
                } else if (hasMoreAttempts) {
                    status = 'prompt';
                } else {
                    status = 'final';
                }

                allAnswers.push({ isCorrect: isAnswerCorrect, status, variable: xmlVariable, answerInput: userAnswer, firstCorrectAnswer});

                return {...answerStatus, [n.attr.id]: status};
            }, {}
        );

        allAnswersCorrect = allAnswers.every((individualAnswer) => {
            return (individualAnswer.status === 'correct');
        });

        if (allAnswersCorrect) {
            // Answer is correct.
            feedbackNode = this.fetchAnswerFeedbackNode(true);
            teCompleted = true;
            this.interactionComplete();
        } else if (hasMoreAttempts) {
            // User failed first attempt
            feedbackNode = this.fetchAnswerFeedbackNode();
            this.onIncorrectAnswer();

            numOfAttempts += 1;
        } else {
            // No more attempts - wrong answer. We set the correct answers globally at the end in evaluateAllChildrenNodes
            feedbackNode = this.fetchAnswerFeedbackNode(false);
            this.onIncorrectAnswerFinal();
            teCompleted = true;
            this.interactionComplete();
        }

        //iff every answer doesn't have a variable property then don't update the student progress
        //will need to be readdressed if a page has 2 match_field inputs and one input gets saved as a variable,
        // so that match_field nodes with variable properties get saved => loop through every object in allAnswers array
        // instead of using .every()
        if(allAnswers.every( individualAnswer => {
            return (individualAnswer.variable)
                && ['correct', 'final'].includes(individualAnswer.status);
        })){
            for(let i = 0; i<allAnswers.length; i++){
                this.saveStudentAnswer(allAnswers[i].variable, allAnswers[i].answerInput);
            }

        }

        const matchFieldEvaluation = {
            currentFeedbackItem: feedbackNode,
            numOfAttempts : numOfAttempts, // numbOfAttempts is the number of attempts the user has attempted
            teCompleted,
            overlayMask: true,
            matchFieldAnswerStatusOb: answerStatusOb,
        };
        return matchFieldEvaluation;
    }

    checkRangeFieldAnswer() {
        const {enableJREAppPlayerContainerButtons} = this.props;
        let {numOfAttempts = 0, teCompleted = false, rangeNodes = [], rangeFieldAnswers = {}} = this.state;
        let feedbackNode = null;
        let hasMoreAttempts = this.hasMoreAttempts();
        let isAnswerCorrect = true;
        let status = null;

        const answerStatusOb = rangeNodes.reduce(
            (answerStatus, n) => {
                let variable = n.attr.variable;
                const userAnswer = rangeFieldAnswers[n.attr.id];
                status = null;
                if (userAnswer !== undefined && parseFloat(userAnswer) >= parseFloat(n.attr.min) &&
                    parseFloat(userAnswer) <= parseFloat(n.attr.max)) {
                    status = 'correct';
                } else if (hasMoreAttempts) {
                    status = 'prompt';
                    isAnswerCorrect = false;
                } else {
                    status = 'final';
                    isAnswerCorrect = false;
                }

                // only save as a variable if there exists a variable attribute for the rangeNode
                if (!isEmpty(userAnswer) && status === 'correct' && !isEmpty(variable)) {
                    setTimeout(function(){
                        this.saveStudentAnswer(variable, userAnswer);
                    }.bind(this), 100);
                }
                else if( status === 'final' && !isEmpty(variable) && !isEmpty(n.attr.answer)){
                    setTimeout(function(){
                        this.saveStudentAnswer(variable, n.attr.answer);
                    }.bind(this), 100);
                }

                return {...answerStatus, [n.attr.id]: status};
            }, {}
        );

        if (isAnswerCorrect) {
            // Answer is correct.
            feedbackNode = this.fetchAnswerFeedbackNode(true);
            teCompleted = true;
            enableJREAppPlayerContainerButtons('requiredNodeNotCompleted','TeNode interactionComplete');
        }
        else if (hasMoreAttempts) {
            feedbackNode = this.fetchAnswerFeedbackNode();
            numOfAttempts += 1;
        }
        else {
            // No more attempts - wrong answer. We set the correct answers globally at the end in evaluateAllChildrenNodes
            feedbackNode = this.fetchAnswerFeedbackNode(false);
            teCompleted = true;
            enableJREAppPlayerContainerButtons('requiredNodeNotCompleted','TeNode interactionComplete');
        }

        const rangeFieldEvaluation = {
            teCompleted,
            numOfAttempts: numOfAttempts,
            overlayMask: true,
            currentFeedbackItem: feedbackNode,
            rangeFieldAnswerStatusOb: answerStatusOb
        };
        return rangeFieldEvaluation;
    }

    hasMoreAttempts() {
        const {numOfAttempts, attempts } = this.state;
        return numOfAttempts < (parseInt(attempts) - 1);
    }

    checkTextAreaAnswer() {
        let {numOfAttempts = 0, teCompleted = false, textAreaNodes = [], textAreaAnswers = {} } = this.state;
        let feedbackNode = null, isAnswerCorrect = true;
        let hasMoreAttempts = this.hasMoreAttempts();

        const answerStatusOb = textAreaNodes.reduce(
            (answerStatus, n) => {
                let variable = n.attr.variable;
                let userAnswer = textAreaAnswers[n.attr.id];
                let status = null;

                if (parseInt(n.attr.allow_empty) || (userAnswer !== undefined && userAnswer.trim().length >= 1)) {
                    status = 'correct';
                } else if (hasMoreAttempts) {
                    status = 'prompt';
                    isAnswerCorrect = false;
                } else {
                    status = 'final';
                    isAnswerCorrect = false;
                }

                if (['correct', 'final'].includes(status)) {
                    this.saveStudentAnswer(variable, userAnswer);
                }

                return {...answerStatus, [n.attr.id]: status};
            }, {}
        );

        if (isAnswerCorrect) {
            feedbackNode = this.fetchAnswerFeedbackNode(true);
            this.interactionComplete();
            teCompleted = true;
        } else if (this.hasMoreAttempts()) {
            feedbackNode = this.fetchAnswerFeedbackNode();
        } else {
            // No more attempts - wrong answer.
            feedbackNode = this.fetchAnswerFeedbackNode(false);
            this.interactionComplete();
            teCompleted = true;
        }

        const textAreaEvaluation = {
            teCompleted,
            currentFeedbackItem: feedbackNode,
            overlayMask: feedbackNode || teCompleted,
            numOfAttempts: numOfAttempts + 1,
            textAreaAnswerStatusOb: answerStatusOb,
        };
        return textAreaEvaluation;
    }

    checkTextFieldAnswer() {
        const {enableJREAppPlayerContainerButtons} = this.props;
        let {numOfAttempts = 0, teCompleted = false, textFieldNodes = [], textFieldAnswers = {}} = this.state;
        let feedbackNode = null;
        let hasMoreAttempts = this.hasMoreAttempts();
        let isAnswerCorrect = true;
        const answerStatusOb = textFieldNodes.reduce(
            (answerStatus, n) => {
                let variable = n.attr.variable;
                let userAnswer = textFieldAnswers[n.attr.id];
                let status = null;

                if (!isEmpty(userAnswer) || parseInt(n.attr.allow_empty)) {
                    status = 'correct';
                } else if (hasMoreAttempts) {
                    status = 'prompt';
                    isAnswerCorrect = false;
                } else {
                    status = 'final';
                    isAnswerCorrect = false;
                }

                if (['correct', 'final'].includes(status)) {
                    this.saveStudentAnswer(variable, userAnswer);
                }

                return {...answerStatus, [n.attr.id]: status};
            }, {}
        );

        if (isAnswerCorrect) {
            // Answer is correct.
            feedbackNode = this.fetchAnswerFeedbackNode(true);
            teCompleted = true;
            enableJREAppPlayerContainerButtons('requiredNodeNotCompleted','TeNode interactionComplete');
        }
        else if (hasMoreAttempts) {
            feedbackNode = this.fetchAnswerFeedbackNode();
            numOfAttempts += 1;
        }
        else {
            // No more attempts - wrong answer.
            feedbackNode = this.fetchAnswerFeedbackNode(false);
            teCompleted = true;
            enableJREAppPlayerContainerButtons('requiredNodeNotCompleted','TeNode interactionComplete');
        }

        const textFieldEvaluation = {
            teCompleted,
            numOfAttempts: numOfAttempts,
            overlayMask: true,
            currentFeedbackItem: feedbackNode,
            textFieldAnswerStatusOb: answerStatusOb
        };
        return textFieldEvaluation;

    }

    fetchAnswerFeedbackNode(correct) {
        let return_feedback;

        const feedback_node = this.props.node.childNamed('feedback_node');
        if (!feedback_node) {
            console.warn('A Feedback Node Was Not Found'); // This shouldn't ever be reached! It likely indicates an XML error.
            return;
        }
        const feedback_nodes = feedback_node.childrenNamed('feedback_item_node');

        if (correct) {
            return_feedback = feedback_nodes.find(n => n.attr.title === 'Correct FB' || n.attr.feedback_type === 'correct');
        } else if (correct === false) { //a user has no more chances to complete the question
            let feedback_node = feedback_nodes.find(n => n.attr.title === 'Incorrect Final FB' || n.attr.feedback_type === 'incorrect_final');
            if (feedback_node) { //if final feedback is found as expected, return it
                return_feedback = feedback_node;
            } else {
                // if final feedback_node was not found in title or feedback_type,
                // fallback to Incorrect Prompt FB (the feedback for more tries)
                return_feedback = feedback_nodes.find(n => n.attr.title === 'Incorrect Prompt FB' || n.attr.feedback_type === 'incorrect_prompt');
            }
        } else { //user still has chances to complete the question
            return_feedback = feedback_nodes.find(n => n.attr.title === 'Incorrect Prompt FB' ||  n.attr.feedback_type === 'incorrect_prompt');
        }

        if (return_feedback === undefined) {
            console.warn('A Feedback Node Was Not Found'); // This shouldn't ever be reached! It likely indicates an XML error.
        }
        return return_feedback;
    }

    interactionComplete() {
        const {enableJREAppPlayerContainerButtons} = this.props;
        enableJREAppPlayerContainerButtons('requiredNodeNotCompleted','TeNode interactionComplete');

        const event_nodes = this.props.node.childrenNamed('event_node');
        event_nodes.forEach(function (event) {
            if (event.attr.name === 'oninteractioncomplete') {
                handleEvent(event);
            }
        });
    }

    onIncorrectAnswer() {
        const event_nodes = this.props.node.childrenNamed('event_node');
        event_nodes.forEach(function (event) {
            if (event.attr.name === 'onIncorrectAnswer') {
                handleEvent(event);
            }
        });
    }

    onIncorrectAnswerFinal() {
        const event_nodes = this.props.node.childrenNamed('event_node');
        event_nodes.forEach(function (event) {
            if (event.attr.name === 'onIncorrectAnswerFinal') {
                handleEvent(event);
            }
        });
    }

    onSubmitClickEvents(node) {
        const event_nodes = node.childrenNamed('event_node');
        event_nodes.forEach(function (event) {
            if (event.attr.name === 'onclick') {
                handleEvent(event);
            }
        });
    }

    feedbackAudioEnded() {        
        
        // this.setState({overlayMask: false, disableTeNodes: false});        
        const el = document.querySelector('#overlayhide');
        if(el != null){
            el.classList.remove("overlay-mask");
        }        
        if (!this.state.teCompleted) {
            this.setState({overlayMask: false});
        }
    }

    feedbackAudioStart() {       
        this.setState({overlayMask: true});
    }

    evaluateAllChildrenNodes(){
        let {
            typesList, // all child nodes present on this page
            numOfAttempts, // number of attempts, before done was clicked
            rangeFieldAnswers, // existing rangeFieldAnswers
            matchFieldAnswers, // existing matchFieldAnswers
        } = this.state;

        let rangeFieldEvaluation = {}, matchFieldEvaluation = {}, textAreaEvaluation = {}, textFieldEvaluation = {}; // all of the node evaluations that will checked
        let rangeFieldAnswerStatusOb = null, matchFieldAnswerStatusOb = null, textFieldAnswerStatusOb = null, textAreaAnswerStatusOb = null; // correct-incorrect status for each node
        let teCompleted = true, overlayMask = true;
        let currentFeedbackItem = null;

        if (typesList.includes('range_field')) {
            rangeFieldEvaluation = this.checkRangeFieldAnswer();
            rangeFieldAnswerStatusOb = rangeFieldEvaluation.rangeFieldAnswerStatusOb;
        }
        if (typesList.includes('match_field')) {
            matchFieldEvaluation = this.checkMatchFieldAnswer();
            matchFieldAnswerStatusOb = matchFieldEvaluation.matchFieldAnswerStatusOb;
        }
        if (typesList.includes('text_area')) {
            textAreaEvaluation = this.checkTextAreaAnswer();
            textAreaAnswerStatusOb = textAreaEvaluation.textAreaAnswerStatusOb;
        }
        if (typesList.includes('text_field')) {
            textFieldEvaluation = this.checkTextFieldAnswer();
            textFieldAnswerStatusOb = textFieldEvaluation.textFieldAnswerStatusOb;
        }

        const nodeEvaluationList = [rangeFieldEvaluation, matchFieldEvaluation, textAreaEvaluation, textFieldEvaluation];

        // for each Child Node Evaluation, decide which Global Evaluation values need to be changed
        for (const nodeEvaluation of nodeEvaluationList){
            if (!isEmpty(nodeEvaluation)){

                // if any nodeEvaluation marks teCompleted or overlayMask as false, then this needs to apply globally (te-node isn't yet done)
                if (!(nodeEvaluation.teCompleted && nodeEvaluation.overlayMask)){
                    teCompleted = false;
                    overlayMask = false;
                }

                // use the "worst feedback" between any of the child nodes.
                if (nodeEvaluation.currentFeedbackItem) { // nodeEvaluation.currentFeedbackItem should ALWAYS exist; this will prevent a crash in case the XML file is messed up.
                    switch (nodeEvaluation.currentFeedbackItem.attr.feedback_type) {
                        case 'correct':
                            // if nodeEvaluation's feedbackNode is correct, set it as currentFeedbackItem IFF currentFeedbackItem was never set (incorrect_prompt, incorrect_feedback take priority)
                            if (!currentFeedbackItem) {
                                currentFeedbackItem = nodeEvaluation.currentFeedbackItem;
                            }
                            break;
                        // incorrect_prompt and incorrect_final will never conflict with one another, because fetchAnswerFeedbackNode will always return the same feedback for a "wrong" answer (numOfAttempts is the same)
                        case 'incorrect_prompt':
                        case 'incorrect_final':
                            currentFeedbackItem = nodeEvaluation.currentFeedbackItem;
                            break;
                    }
                }
            }
        }

        // set the answer fields to the correct ones, IFF the global feedback status is incorrect_final
        if (currentFeedbackItem && currentFeedbackItem.attr.feedback_type === 'incorrect_final') { // currentFeedbackItem should ALWAYS exist; this will prevent a crash in case the XML file is messed up.
            // this checks to ensure student failed the range-node (and not another node) so that their correct range-node answers aren't replaced
            if (!isEmpty(rangeFieldEvaluation) && rangeFieldEvaluation.currentFeedbackItem.attr.feedback_type === 'incorrect_final') {
                rangeFieldAnswers = this.getCorrectRangeFieldAnswers();
            }
            if (!isEmpty(matchFieldEvaluation) && matchFieldEvaluation.currentFeedbackItem.attr.feedback_type === 'incorrect_final') {
                matchFieldAnswers = this.getCorrectMatchFieldAnswers();
            }
        }
        const childrenNodeEvaluation = {
            teCompleted,
            overlayMask,
            numOfAttempts: numOfAttempts + 1,
            currentFeedbackItem,
            rangeFieldAnswerStatusOb, matchFieldAnswerStatusOb, textFieldAnswerStatusOb, textAreaAnswerStatusOb,
            rangeFieldAnswers, matchFieldAnswers,
        };
        return childrenNodeEvaluation;
    }

    submitAction(e, node) {
        const childrenNodeEvaluation = this.evaluateAllChildrenNodes();

        if (childrenNodeEvaluation.teCompleted){
            setTimeout(function(){ //if teCompleted, ensure updateprogress request is sent before new feedback state is set
                this.updateAnswerProgress().then(() => {
                    this.setState({...childrenNodeEvaluation});
                    this.onSubmitClickEvents(node);
                });
            }.bind(this), 400);
        } else {
            this.setState({...childrenNodeEvaluation});
            this.onSubmitClickEvents(node);
        }
    }

    render() {
        const {textFieldAnswerStatusOb = null, rangeFieldAnswerStatusOb = null, matchFieldAnswerStatusOb = null,
            numOfAttempts = 0, fontsize = '', fontcolor = ''} = this.state;
        const {moduleURL='', } = this.props;

        const elementsList = this.props.node.children.map(n => {
            switch (n.name) {
                case 'button_node':
                    return <ButtonNode moduleURL={moduleURL} onClick={(e) => this.submitAction(e, n)} key={n.attr.id}
                                       node={n}
                    />;
                case 'action_button_node':
                    return <ActionButtonNode moduleURL={moduleURL} onClick={(e) => this.submitAction(e,n)} key={n.attr.id}
                                             node={n}
                    />;
                case 'text_area_node':
                    return <TextAreaNode onChange={this.onChangeTextAreaField.bind(this)} key={n.attr.id}
                                         answer={this.state.textAreaAnswers[n.attr.id]} node={n}
                                         ref={(textArea) => this.textArea = textArea} {...{fontsize, fontcolor} }
                    />;
                case 'range_field_node':
                    return <RangeFieldNode answerStatus={rangeFieldAnswerStatusOb && rangeFieldAnswerStatusOb[n.attr.id]}
                                           answer={this.state.rangeFieldAnswers[n.attr.id]}
                                           onChange={this.onChangeRangeField.bind(this)} key={n.attr.id}
                                           node={n} {...{fontcolor}}
                    />;
                case 'text_field_node':
                    return <TextFieldNode answerStatus={textFieldAnswerStatusOb && textFieldAnswerStatusOb[n.attr.id]}
                                          answer={this.state.textFieldAnswers[n.attr.id]}
                                          onChange={this.onChangeTextField.bind(this)} key={n.attr.id} node={n}
                    />;
                case 'match_field_node':
                    return <MatchFieldNode answerStatus={matchFieldAnswerStatusOb && matchFieldAnswerStatusOb[n.attr.id]}
                                           key={n.attr.id} answer={this.state.matchFieldAnswers[n.attr.id]} node={n}
                                           {...{fontcolor}} onChangeMatchField={this.onChangeMatchField.bind(this)}
                    />;
                default:
                    return null;
            }
        });

        return (
            <div className="te-node">
                {this.state.overlayMask ? <div id="overlayhide" className="overlay-mask" /> : ''}
                <div>
                    {elementsList}
                </div>
                {
                    this.state.currentFeedbackItem &&
                    <div className="node feedback-item">
                        {/* numOfAttempts was passed with key or else component won't re-render with same id/key. */}
                        <FeedbackItem
                            moduleURL={moduleURL}
                            node={getDataFromFeedbackNode(this.state.currentFeedbackItem)}
                            onAudioStart={this.feedbackAudioStart.bind(this)}
                            onAudioEnded={this.feedbackAudioEnded.bind(this)}
                            ref={(feedbackItem) => this.feedbackItem = feedbackItem}
                            key={`${this.state.currentFeedbackItem.attr.id}-${numOfAttempts}`}
                        />
                    </div>
                }
            </div>
        );
    }
}

TeNode.propTypes = {
    node: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return {
        answers: state.answers.list,
        users :  state.auth.users // joyson
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveAnswer: (answer,users) => {
            dispatch(saveAnswer(answer,users));
        },
        formatErrors: (err, redirectTo) => dispatch(formatErrors(err, redirectTo)),
    };
};

const TeNodeContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(TeNode);

export default TeNodeContainer;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/te-node.js